import { ClarionDrawer, ClarionDrawerProps } from '../../clarion/ClarionDrawer';
import { NavigationContent } from './SideNavigation';
import { SideNavigationProvider } from './SideNavigationContext';

export function MobileNavigationDrawer(props: Omit<ClarionDrawerProps, 'children'>) {
  return (
    <ClarionDrawer title="Recap" side="left" {...props}>
      <div className="h-full flex flex-col touch-manipulation">
        <SideNavigationProvider isCollapsed={false}>
          <NavigationContent />
        </SideNavigationProvider>
      </div>
    </ClarionDrawer>
  );
}
